import React from "react";

const percent = (progress) => {
  if (progress.mode === "exact") return Math.round((progress.current / progress.total) * 100);
  if (progress.mode === "phase_relative" && progress.phase_progress) {
    return Math.round((progress.phase_progress.current / progress.phase_progress.total) * 100);
  }
  return 0;
};

export default function JourneyProgress({ progress, showTrack = true }) {
  const current = progress?.mode === "exact" ? progress.current : null;
  const total = progress?.mode === "exact" ? progress.total : null;
  const phase = progress?.mode === "phase_relative" ? progress.phase_progress : null;
  const label = current
    ? `Treatment journey, step ${current} of ${total}`
    : phase
      ? `Treatment journey, question ${phase.current} in this phase`
      : "Treatment journey progress";
  return (
    <div
      className={`treatment-journey-progress treatment-journey-progress--${progress?.mode || "indeterminate"}`}
      {...(showTrack ? {
        role: "progressbar",
        "aria-label": label,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        ...(progress?.mode === "indeterminate" ? {} : { "aria-valuenow": percent(progress) }),
      } : {})}
    >
      {showTrack && (
        <div className="treatment-journey-progress__track">
          <div className="treatment-journey-progress__fill" style={{ width: `${percent(progress || { mode: "indeterminate" })}%` }} />
        </div>
      )}
      <span className="treatment-journey-progress__label">
        {current
          ? `QUESTION ${current} OF ${total}`
          : phase
            ? `QUESTION ${phase.current} IN THIS PHASE`
            : ""}
      </span>
    </div>
  );
}
